import { render, staticRenderFns } from "./BasesTable.vue?vue&type=template&id=093e3711"
import script from "./BasesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BasesTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports